import { Box, Button, Grid, IconButton } from "@material-ui/core"
import React, { memo, useMemo } from "react"
import { VariaveisAmbiente } from "ambiente"
import { MesaIcon } from "utils/Icons/mesa-icon"
import { MenuConta } from "../../../cardapio-menu-conta"
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { EnumDeviceType } from "ambiente/ambiente-tipos"
import classNames from "classnames"
import { useStyles } from "./cardapio-header-navbar-options-styles"
import { MesaModel } from "api/pedidos/models"
import { BarraPesquisa } from "../../../cardapio-barra-pesquisa"
import { CardapioHeaderNavBarProps } from "../../cardapio-header-navbar"
import { TokenIntegradorModel } from "api/master/models/token/token-integrador-model"
import { MeuMenu } from "../../../cardapio-meu-menu"
import { DrawerMenu } from "../../../cardapio-drawer-menu"
import { ConfigDeliveryModel } from "api/cardapio/models/delivery/config-delivery-model"
import { useThemeQueries } from "components/dialogs/dialog-adicionar-produto-com-subitem/util-styles"
import { ButtonResumoPedido } from "components/modals/resumo-pedido/components/button-resumo-pedido"

export interface CardapioHeaderNavbarOptionsProps {
    adminLogado: boolean;
    capa: string;
    configuracoes: any;
    empresa: any;
    mesaId: string
    mesa: MesaModel | null
    pesquisa: boolean
    usuarioToken: TokenIntegradorModel | undefined
    configuracoesDelivery: ConfigDeliveryModel

    // FUNCTIONS
    quandoPesquisar: CardapioHeaderNavBarProps['quandoPesquisar']
    onClickMesa: () => void
    setCarregando: (value: boolean) => void;
    onPesquisaClick: () => void;
    onEditarConfiguracoesClick: () => void;
    onVisualizarClick: () => void;
    logout: () => void;
    abrirPedidoResumo: () => any;
    visualizacao: 'configuracao' | 'gerarQrCode' | 'cardapio' | 'acompanharPedido'
}

export const CardapioHeaderNavbarOptions = memo(({
    capa,
    configuracoes,
    adminLogado,
    empresa,
    logout,
    onEditarConfiguracoesClick,
    onPesquisaClick,
    onVisualizarClick,
    setCarregando,
    abrirPedidoResumo,
    mesaId,
    mesa,
    onClickMesa,
    pesquisa,
    quandoPesquisar,
    usuarioToken,
    visualizacao,
    configuracoesDelivery
}: CardapioHeaderNavbarOptionsProps) => {
    const { isMobile } = useThemeQueries()
    const classes = useStyles()

    const isCordova = VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA

    const ImagemLogo = memo(({ validateCordova }: { validateCordova?: boolean }) => {
        return (
            <>
                {Boolean(configuracoes.logo) && (validateCordova ? !isCordova : true) ? (
                    <img src={configuracoes.logo || ''} className={classNames(classes.logo, classes.logoRounded)} alt="Logotipo do Cliente" />
                ) : null}
            </>
        )
    })

    const meuMenu = useMemo(() => (
        <MeuMenu
            setCarregando={setCarregando}
            visualizacao={visualizacao}
            adminLogado={adminLogado}
            onVisualizarClick={onVisualizarClick}
        />
    ), [adminLogado, onVisualizarClick, setCarregando, visualizacao])

    return (
        <Box style={{
            width: '100%',
            padding: 8
        }}>
            <Grid container spacing={2} justify={visualizacao !== 'cardapio' ? 'flex-end' : 'flex-start'}>
                {visualizacao !== 'acompanharPedido' && meuMenu}
                <Grid item xs={'auto'}>
                    <Box display={"flex"} alignItems={"center"}>
                        <ImagemLogo />
                    </Box>
                </Grid>
                {visualizacao === 'acompanharPedido' && meuMenu}
                {adminLogado && isMobile && (
                    <DrawerMenu
                        capa={capa}
                        logoUrl={configuracoes.logo}
                        adminLogado={adminLogado}
                        setCarregando={setCarregando}
                        onEditarConfiguracoesClick={onEditarConfiguracoesClick}
                        onVisualizarClick={onVisualizarClick}
                        logout={logout}
                        buscarProds={onPesquisaClick}
                        mesaId={mesaId}
                    />
                )}
                {visualizacao === 'cardapio' && (
                    <>
                        {isCordova && (
                            <Grid item xs="auto">
                                <Button variant="contained" color="primary" className={classes.mesaButton} onClick={onClickMesa}>
                                    <MesaIcon tipo='BUTTON_PRIMARY' />
                                    {mesa ? `Mesa ${mesa.codigo}` : 'Sem Mesa'}
                                </Button>
                            </Grid>
                        )}
                        {!isMobile ? (
                            <Grid item xs>
                                <BarraPesquisa
                                    pesquisa={false}
                                    onPesquisaClick={onPesquisaClick}
                                    quandoPesquisar={quandoPesquisar}
                                    fixo={visualizacao === 'cardapio'}
                                    isPedidoLocal={!!mesaId}
                                    modo="static"
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={!adminLogado ? true : 'auto'}>
                                <Box width="100%" height="100%" display="flex" justifyContent="flex-end" alignItems="center">
                                    <IconButton
                                        onClick={onPesquisaClick}
                                        aria-label="pesquisar"
                                        aria-haspopup="true"
                                        className={classes.searchIcon}
                                        style={{
                                            pointerEvents: !pesquisa ? 'all' : 'none',
                                            opacity: !pesquisa ? 1 : 0,
                                            padding: 4
                                        }}
                                    >
                                        <SearchRoundedIcon style={{ fontSize: '35px' }} />
                                    </IconButton>
                                </Box>
                            </Grid>
                        )}
                    </>
                )}
                {(mesaId || mesa ? adminLogado ? true : false : configuracoesDelivery.produtoEntrega ?? adminLogado) && (
                    <Grid item xs="auto" alignItems="center" style={{ display: 'flex' }}>
                        <MenuConta
                            logout={logout}
                            adminLogado={adminLogado}
                            setCarregando={setCarregando}
                            nomeUsuario={usuarioToken?.saudacao}
                            tema={configuracoes}
                            empresa={empresa}
                        />
                    </Grid>
                )}
                {(mesaId || mesa) && visualizacao === 'cardapio' && (
                    <Grid item xs="auto">
                        <ButtonResumoPedido
                            abrirPedidoResumo={abrirPedidoResumo}
                        />
                    </Grid>
                )}
            </Grid>
        </Box>
    )
})

CardapioHeaderNavbarOptions.displayName = "CardapioHeaderNavbarOptions"